import React, { useState } from 'react';
import { useEffect } from 'react';
import AppApi from '../../../Api/AppApi';
let ExistingDisposition = (props) => {
    let [items, setItems] = useState([])
    useEffect(() => {
        setItems(props.data)
    }, [props.data])



    return (
        <div class="panel border panel-default">
            <div class="panel-heading">
                <div class="panel-title">Existing Categories
                    <div class="badge badge-info ng-binding ms-1">{items.length}</div>
                </div>
            </div>
            <div class="panel-body p-3">

                {items.map((data, index) => {
                    return (
                        <p class="ng-binding ng-scope"  >
                            <i class="fa fa-building me-1 fa-1x"></i> {data.venue_name}
                        </p>
                    );
                })}

            </div>
        </div>
    )
}

export default ExistingDisposition